import * as React from 'react';
import {FrameAction, FrameActionEnum} from './FrameAction';

/**
 * Stav frame.
 */
export interface FrameState {
    /**
     * Zda je pozastaveno odebírání z fronty zpráv.
     */
    postSuspended: boolean;

    /**
     * Fronta zpráv.
     */
    messages: any[];
}

/**
 * Výchozí stav frame.
 *
 * @ignore
 */
export const frameInitialState: FrameState = {
    postSuspended: false,
    messages: [],
};

/**
 * Reducer stavu frame.
 *
 * @param state - Aktuální stav.
 * @param action - Akce.
 * @returns Nový stav.
 */
export const FrameReducer: React.Reducer<FrameState, FrameAction> = (
    state: FrameState = frameInitialState,
    action?: FrameAction,
): FrameState => {
    if (!action) {
        return state;
    }

    switch (action.type) {
        case FrameActionEnum.SET_POST_SUSPENDED:
            return {
                ...state,
                postSuspended: action.suspended,
            };

        case FrameActionEnum.POST_MESSAGE:
            return {
                ...state,
                messages: [...state.messages, action.message],
            };

        case FrameActionEnum.CLEAR_MESSAGES: {
            return {
                ...state,
                messages: [],
            };
        }

        default:
            return state;
    }
};
